<template>
  <div class="silder-container" ref="container" :style="{height:itemHeight}">
    <div class="slider-wrapper" ref="wrapper">
      <div class="slider-item" v-for="(item,index) in list" :key="index">
        <slot :row="item"></slot>
      </div>
    </div>
    <template v-if="control&&list.length>1">
      <div class="button-prev" @click="prev">
        <img src="./arrow_left.svg" alt="">
      </div>
      <div class="button-next" @click="next">
        <img src="./arrow_right.svg" alt="">
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'banner', //banner,slider
      },
      control:{
        default:true,
        type:Boolean,
      },
      direction: {
        type: String,
        default: 'horizontal', //horizontal,vertical
      },
      list: {
        type: Array,
        default: [],
      },
      itemWidth: {
        type: String,
        default: '180px',
      },
      itemHeight: {
        type: String,
        default: '200px'
      },
      loop: {
        type: Boolean,
        default: true,
      },
      interval: {
        type: Number,
        default: 7000,
      },
    },
    data() {
      return {
        offset: 0,
        maxOffset:0,
        widthTotal: 0, //wrapper宽度
        widthItem: 0, //单个
        heightTotal: 0,
        time:null,
      }
    },
    watch: {
      list(curr) {
        if (curr.length) {
          setTimeout(() => {
            if (this.direction === 'horizontal') this.init()
            if (this.direction === 'vertical') this.initVertical()
          }, 20);
        }
      }
    },
    methods: {
      initVertical() {
        const container = this.$refs['container'];
        const wrapper = this.$refs['wrapper'];
        const slide = wrapper.getElementsByClassName('slider-item');
        Array.from(slide).forEach(e => {
          e.style.height = this.itemHeight
           e.style.float = "none"
        })
        this.heightTotal = parseInt(this.itemHeight) * slide.length
        wrapper.style.height = this.heightTotal + 'px';
        
        if (this.loop) {
           this.time=setInterval(() => {
            this.nextVertical()
          }, this.interval);
        }
      },
      nextVertical() {
        const container = this.$refs['container']
        const wrapper = this.$refs['wrapper'];
        this.offset = this.offset - parseInt(this.itemHeight);
        if (this.offset < -this.heightTotal + container.offsetHeight) this.offset = 0;
        wrapper.style.top = this.offset + 'px';
      },
      init() {
        if(this.time)clearInterval(this.time)
        const container = this.$refs['container'];
        const wrapper = this.$refs['wrapper'];
        const slide = wrapper.getElementsByClassName('slider-item');
        Array.from(slide).forEach(e => {
          e.style.width = (this.type == 'banner' ? container.offsetWidth + 'px' : this.itemWidth)
        })
        this.widthItem = slide[0].offsetWidth;
        this.widthTotal = this.widthItem * wrapper.children.length;
        wrapper.style.width = this.widthTotal + 'px';

        this.maxOffset=wrapper.offsetWidth-container.offsetWidth
        if(this.maxOffset>0&&this.loop){
           this.time=setInterval(() => {
            this.next()
          }, this.interval);
        }

      },

      prev() {
         clearInterval(this.time)
        const wrapper = this.$refs['wrapper'];
        const offset =  this.offset + this.widthItem;
         if(offset>0){
             wrapper.style.left = -this.maxOffset+'px';
             this.offset = -this.maxOffset
         }else {
            if( offset + this.widthItem>0){
              wrapper.style.left = '0px';
              this.offset = 0;
            }else{
               wrapper.style.left = offset+'px';
              this.offset =offset
            }
         }
        this.time=setInterval(() => {
          this.next()
        }, this.interval);
        
      },
      next() {
        clearInterval(this.time)
        const wrapper = this.$refs['wrapper'];
        const offset =  this.offset - this.widthItem;
        if(offset>=-this.maxOffset){
           if( offset - this.widthItem<-this.maxOffset){
              wrapper.style.left = -this.maxOffset + 'px';
           }else{
             wrapper.style.left = offset + 'px';

           }
        }else {
            wrapper.style.left = '0px';
        }
        this.offset=parseInt(wrapper.style.left)
        this.time=setInterval(() => {
            this.next()
          }, this.interval);
      },
    },
    mounted() {
      if (this.list.length) {
        setTimeout(() => {
          if (this.direction === 'horizontal') this.init()
          if (this.direction === 'vertical') this.initVertical()
        }, 20);
      }
      window.onresize=()=>{
        this.init()
      }
    },
    destroyed(){
      clearInterval(this.time)
    }

  }

</script>

<style lang="scss">
  .silder-container {
   
    overflow: hidden;
    position: relative;
    &:hover{
      .button-prev{
      left: 0px;
      }
      .button-next{
      right:0px;
    }
      
    }
    div[class^="button-"]{
      position: absolute;
      width: 50px;
      background-color: rgba(0, 0, 0, .3);
      border-radius: 5px;
      transform:translateY(-50%);
      top: 50%;
      transition: .3s;
      cursor: pointer;
      &:hover{
         background-color: rgba(0, 0, 0, .6);
      }
      img{
        width: 100%;
      }
    }

    .button-prev{
      left: -50px;
       
    }
    .button-next{
      right:-50px;
    }
    .slider-wrapper {
      &:after,
      &::before {
        content: '';
        height: 0;
        display: block;
        clear: both;
      }

      transition: .3s;
      // transition-timing-function:linear;
      position: relative;
      left: 0;
      top:0;
    }

    .slider-item {
        float: left;
    }
  }

</style>
